/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';

import ModalWithActions from '../../ModalWithActions';
import ChartSelector from '../../shared/atoms/Widget/ChartSelector';
import useTimeRangeOptions from '../../../hooks/useTimeRangeOptions';

const SelectorChartWidgetModal = ({
  modalShow,
  onSenderModalHide,
  onSubmit,
  current,
  ...props
}) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState(true);
  const { timeRanges } = useTimeRangeOptions();

  const validateForm = vals => {
    const errors = {};

    if (!vals.title.length) errors.title = t('validation.required');
    if (!vals.chart.length) errors.chart = t('validation.required');
    if (!vals.timeRange.length) errors.timeRange = t('validation.required');
    errors.items = [];
    vals.items.forEach((item, index) => {
      errors.items.push({});
      if (!item.asset) {
        errors.items[index].asset = t('validation.required');
      }
      if (!item.sensor) {
        errors.items[index].sensor = t('validation.required');
      }
    });

    if (
      errors.title ||
      errors.chart ||
      errors.timeRange ||
      errors.items.some(item => item.asset || item.sensor)
    ) {
      setIsValid(false);
    } else {
      delete errors.items;
      setIsValid(true);
    }

    return errors;
  };

  return (
    <ModalWithActions
      show={modalShow}
      modalTitle={t('atoms.widget.selector.header')}
      modalText=""
      action={() => formRef.current?.handleSubmit()}
      onHide={onSenderModalHide}
      btActionDisabled={!isValid}
      inputComponent={
        <Formik
          innerRef={formRef}
          initialValues={{
            title: current?.title || '',
            chart: current?.chart || '',
            timeRange: current?.timeRange
              ? Object.keys(timeRanges).find(
                  k => timeRanges[k].time === current.timeRange,
                )
              : '',
            items: current?.items || [{ asset: '', sensor: '' }],
          }}
          validateOnBlur
          validateOnChange
          validate={validateForm}
          enableReinitialize={false}
          onSubmit={onSubmit}
        >
          {formikProps => <ChartSelector {...formikProps} {...props} />}
        </Formik>
      }
    />
  );
};

SelectorChartWidgetModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  current: PropTypes.object.isRequired,
  onSenderModalHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SelectorChartWidgetModal;
